module.exports = __webpack_public_path__ + "static/img/1.8c220c7d.jpg";